<template>
  <b-card>
    <div class="row">
      <div class="col-6 d-flex align-items-center justify-content-lg-start">
        <Button
          v-if="showBackButton && actionType === 'save' || 'add'"
          :label="$t('List page')"
          size="md"
          icon="ArrowLeftIcon"
          show-icon
          class="mb-1"
          @click="backNavigationAction"
        />
      </div>
      <div class="col-6 d-flex justify-content-end">
        <Button
          v-if="showSearchButton"
          :label="$t('Search')"
          size="md"
          icon="SearchIcon"
          show-icon
          @click="showSearchField"
        />
      </div>
    </div>
    <b-row class="position-relative">
      <b-col
        v-if="!showSearchButton"
        md="4"
      >
        <b-row>
          <Alert
            :show="showFormErrorAlert"
            :message=" $t('Customer\'s account name or account number or customer id is required')"
          />

          <b-col md="12">
            <InputField
              id="account-number"
              v-model="searchParams.accountNumber"
              :label="$t('Account Number')"
              :placeholder="$t('Enter account number')"
              type="number"
            />
          </b-col>

          <b-col md="12">
            <InputField
              id="account-name"
              v-model="searchParams.accountName"
              :label="$t('Account Name')"
              :placeholder="$t('Enter account name')"
              type="text"
            />
          </b-col>
          <b-col md="12">
            <InputField
              id="reference-number"
              v-model="searchParams.referenceNumber"
              :label="$t('Reference Number')"
              :placeholder="$t('Enter reference number')"
              type="text"
            />
          </b-col>

          <b-col md="12">
            <Button
              :label="$t('Search')"
              size="md"
              class="mt-2"
              block
              @click="handleSearch"
            />
          </b-col>
        </b-row>

      </b-col>
      <b-col
        v-if="showSearchButton"
        :md="showSearchButton === true ? '12' : '8'"
      >
        <div v-if="showCustomerInfo">
          <validation-observer ref="accountClosureRules">
            <app-collapse
              class="business-items mb-4"
              type="margin"
              accordion
            >
              <app-collapse-item
                :title="$t('Account Summary')"
                class="card-item"
                is-visible
              >
                <b-row>
                  <b-col md="4">
                    <InputField
                      id="account-name"
                      v-model="customer.accountName"
                      :label="$t('Account Name')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="account-number"
                      v-model="customer.accountNumber"
                      :label="$t('Account Number')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="product-name"
                      v-model="customer.productName"
                      :label="$t('Product Name')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="NUBAN"
                      v-model="customer.accountNumber"
                      :label="$t('NUBAN')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="branch"
                      v-model="customer.branchName"
                      :label="$t('Branch')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="account-status"
                      v-model="customer.accountStatus"
                      :label="$t('Account Status')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="ledger-balance"
                      v-model="customer.ledgerBalance"
                      :label="$t('Ledger Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="available-balance"
                      v-model="customer.availableBalance"
                      :label="$t('Available Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="withdrawable-balance"
                      v-model="customer.withdrawableBalance"
                      :label="$t('Withdrawable Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                </b-row>
              </app-collapse-item>
            </app-collapse>

            <h5 class="text-capitalize mb-3">
              {{ $t('Posting Details') }}
            </h5>
            <b-row>
              <b-col md="6">
                <InputField
                  id="ledger-balance"
                  v-model="customer.ledgerBalance"
                  :label="$t('Ledger Balance')"
                  type="text"
                  readonly
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="instrument-no"
                  v-model="accountClosureData.instrumentNumber"
                  :label="$t('Instrument No')"
                  :placeholder="$t('Enter instrument no')"
                  type="text"
                  rules="required"
                  :error-name="$t('Instrument No')"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="closure-reason"
                  v-model="accountClosureData.closureReason"
                  :label="$t('Closure Reason')"
                  rules="required"
                  :error-name="$t('Closure Reason')"
                  :reduce="option => option.value"
                  :options="accountClosureReasonOptions"
                  item="label"
                  :placeholder="$t('Select Closure Reason')"
                  :set-selected="closureReasonNarration"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="narration"
                  v-model="accountClosureData.narration"
                  :label="$t('Narration')"
                  :placeholder="$t('Enter narration')"
                  type="text"
                  rules="required"
                  :error-name="$t('narration')"
                  readonly
                />
              </b-col>
            </b-row>
          </validation-observer>
          <!-- <b-row>
            <b-col md="6"> -->
          <div class="button-center mt-5">
            <div>
              <Button
                :label="$t('Close Account')"
                :loading="isLoading"
                :disabled="isDisabled"
                size="lg"
                @click="handleSubmit"
              />
            </div>
          </div>
          <!-- </b-row> -->
        </div>
      </b-col>
    </b-row>

    <b-modal
      id="search-modal"
      ref="search-modal-lg"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Customer Details')"
      cancel-title-only
      @hidden="resetModal"
    >

      <b-table
        ref="customerListTable"
        select-mode="single"
        :items="customerList"
        responsive
        :fields="translatedTableHeaders"
        primary-key="id"
        selectable
        show-empty
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
        @row-selected="onSelectCustomer"
      >

        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>

      </b-table>

      <TablePagination
        v-model="currentPage"
        :from="from"
        :to="to"
        :total-rows="totalEntries"
        :per-page="perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>

    </b-modal>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>

import {
  BCard, BRow, BCol, BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { required, positive } from '@validations'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { tableMixins } from '@core/mixins/table'
import { mapActions, mapGetters } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import TablePagination from '@/views/components/table/TablePagination.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toBalance } from '@/helpers/formatAmount'
import { closureReasonOptions } from '@/helpers/data'
import InputField from '../../../forms/InputField.vue'
import SelectField from '../../../forms/SelectField.vue'
import Button from '../../../components/button/Button.vue'
import Alert from '../../../components/alert/Alert.vue'

export default {
  components: {
    BRow,
    BCol,
    InputField,
    SelectField,
    Button,
    TablePagination,
    Alert,
    BTable,
    BCard,
    FullScreenSpinner,
    ValidationObserver,
    AppCollapse,
    AppCollapseItem,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [sweetAlert, tableMixins, modalMixins],
  data() {
    return {
      actionType: 'save',
      isDisabled: false,
      isLoading: false,
      showFormErrorAlert: false,
      showCustomerInfo: false,
      showSearchButton: false,
      showBackButton: false,
      isEditable: true,
      required,
      positive,
      showSpinner: false,
      sortDesc: false,
      currentPage: 1,
      perPage: 10,
      sortBy: 'accountName',
      searchParams: {
        accountNumber: null,
        accountName: null,
        referenceNumber: null,
      },
      accountClosureData: {
        instrumentNumber: '',
        closureReason: '',
        narration: '',
      },
      accountClosureReasonOptions: closureReasonOptions,
      customerList: [],
      customer: {
        accountName: '',
        accountNumber: '',
        productName: '',
        branchName: '',
        accountStatus: '',
        ledgerBalance: '',
        availableBalance: '',
        withdrawableBalance: '',
        minimumBalanceRequired: 0,
        accountCreationChannel: null,
        originalLedgerBalance: 0,
      },
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
      ],
    }
  },
  computed: {
    totalEntries() {
      return this.customerList.length
    },
    numberOfPages() {
      return Math.floor((this.totalEntries + this.perPage - 1) / this.perPage)
    },
    from() {
      return (this.currentPage * this.perPage) - (this.perPage - 1)
    },
    to() {
      return Math.min(this.from + this.perPage - 1, this.totalEntries)
    },
    ...mapGetters({
      userDetails: 'auth/getCurrentUser',
    }),
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  methods: {
    ...mapActions({
      searchCustomerAccount: 'account/searchCustomerAccountAction',
      accountClosure: 'posting/accountClosureAction',
      getUserBalance: 'account/getCASABalanceAction',
    }),
    async handleSearch() {
      try {
        const isSearchParamsNotEmpty = Object.values(this.searchParams).every(params => (params === null || params === ''))
        if (!isSearchParamsNotEmpty) {
          this.showFormErrorAlert = false
          this.showSpinner = true
          const response = await this.searchCustomerAccount({
            search: this.searchParams,
            page: this.currentPage,
            limit: this.perPage,
            permission: 'ACCOUNT_CLOSURE_POSTING',
          })
          const { status, data } = response
          if (status === 200 && data?.data) {
            this.customerList = data.data
            this.totalCount = data.recordCount
            this.showSpinner = false
            this.$root.$emit('bv::show::modal', 'search-modal')
          } else {
            this.customerList = []
            this.totalCount = data.recordCount
            this.$root.$emit('bv::show::modal', 'search-modal')
          }
        } else {
          this.showFormErrorAlert = true
          this.showSpinner = false
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    closureReasonNarration(val) {
      const text1 = this.$t('Account closure posting:')
      const text2 = this.$t('due to')
      this.accountClosureData.closureReason = val
      this.accountClosureData.narration = `${text1} ${this.customer.accountNumber} | ${text2} ${this.accountClosureData.closureReason}`
    },
    async onSelectCustomer(items) {
      try {
        const [customer] = items
        this.hideModal('search-modal')
        this.showSpinner = true
        this.showBackButton = true
        const response = await this.getUserBalance({ accountNumber: customer.accountNumber, permission: 'VIEW_ACCOUNT_CLOSURE_POSTING' })
        const { data, status } = response
        if (status === 200) {
          this.customer = {
            ...customer,
            availableBalance: toBalance(data.availableBalance),
            withdrawableBalance: toBalance(data.withdrawableBalance),
            ledgerBalance: toBalance(data.ledgerBalance),
            originalLedgerBalance: data.ledgerBalance,
          }
          if (data.accountStatus === 'Closed') {
            const closedText = this.$t('has been closed.')
            this.alertError({ text: `${data.accountName} - ${data.accountNumber} ${closedText}` })
            this.isDisabled = true
          } else if (data.hasLoanOutstandingAmount === true) {
            this.isDisabled = true
          } else if (Number(data.totalLien) > 0) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
        }
        this.accountClosureData.accountNumber = customer.accountNumber
        this.accountClosureData.branchCode = customer.branchCode
        const postingText = this.$t('Account closure posting:')
        const dueText = this.$t('due to')
        this.accountClosureData.narration = `${postingText} ${this.customer.accountNumber} | ${dueText} ${this.accountClosureData.closureReason}`
        this.showCustomerInfo = true
        this.showSearchButton = true
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async handleSubmit() {
      this.$refs.accountClosureRules.validate().then(success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to close this account:')
          this.confirm(this.accountClosureAction, { text: `${areYouSure} ${this.customer.accountNumber} ?` })
        }
      })
    },
    async accountClosureAction() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const postingApprovalModel = {
          amount: this.customer.originalLedgerBalance,
          accountName: this.customer.accountName,
          initiatedBy: '',
          approvedBy: '',
          postingType: 'AccountClosurePosting',
        }
        const formData = {
          accountNumber: this.customer.accountNumber,
          branchCode: this.customer.branchCode,
          closureReason: this.accountClosureData.closureReason,
          instrumentNumber: this.accountClosureData.instrumentNumber,
          initiator: this.userDetails.email,
          postingApprovalModel,
        }
        const response = await this.accountClosure(formData)

        const { status, data } = response
        if (status === 200 && data.isSuccessful) {
          this.showCustomerInfo = false
          this.isLoading = false
          this.isDisabled = false
          this.resetInputField()
          this.resetSearchParams()
          this.alertSuccess({ text: this.$t('Your Account Closure request was successful') })
          this.$router.push('account-closure')
        }
        if (status === 200 && !data.isSuccessful) {
          const requestFailed = this.$t('Your Account Closure request failed. Reason:')
          this.alertError({ text: `${requestFailed} ${data.message}` })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    resetInputField() {
      this.searchParams = { ...null }
      this.accountClosureData = { ...null }
      this.customer = { ...null }
      this.isLoading = false
      this.isDisabled = false
      this.showCustomerInfo = false
      this.showSearchButton = false
      this.showBackButton = false
    },
    showSearchField() {
      this.showSearchButton = false
      this.resetSearchParams()
    },
    resetSearchParams() {
      this.searchParams.accountNumber = null
      this.searchParams.accountName = null
      this.searchParams.referenceNumber = null
    },
    resetModal() {
      this.customerList = []
    },
    backNavigationAction() {
      this.showBackButton = true
      this.$router.push({
        name: 'account-closure',
      })
    },
  },
}
</script>
<style scoped>
 [dir] .demo-inline-spacing > *, .custom-control , .custom-control-inline, .custom-checkbox {
    margin-top: 0rem !important;
}
.card-item {
  border: 1px solid #d8d6de !important;
  border-radius: 0.358rem
}

.button-center {
  display: flex;
  justify-content: center;
}
</style>
